import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

// The typeface the website is set in, served from here rather than from a font service: a
// self-hosted server does not phone anybody to draw its letters.
import '@fontsource-variable/inter';

import App from './App';
import AuthProvider from './auth/AuthProvider';
import './i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A library does not change while somebody walks through it, so half a minute of
      // freshness turns going back a screen into no request at all.
      staleTime: 30_000,

      // One retry: a server that is down says so quickly, and a request that failed on the
      // way is usually fine the second time.
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');

if (!container) {
  throw new Error('The root element is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
